<template>
  <div class="game-container" :style="getStyle(startGameConfig)">
    <div v-if="objectExist(imageData)" class="main-image-container" :style="getImageStyle(imageData)"></div>
    <table :style="startGameConfig.tableStyle">
      <tr v-for="(row, i) in diagram" :key="'row_' + i">
        <td
          v-for="(col, j) in row"
          :key="'col_' + j"
          @mouseover="selectLetter"
          @mousedown="checkLetter"
          @touchstart="touchLetter"
          @touchend="touchLetter"
          @touchmove="touchLetter"
          :id="i + '-' + j + '-' + diagram[i][j].letter"
          :ref="i + '-' + j + '-' + diagram[i][j].letter"
          :style="[getStyle(startGameConfig.td), { background: diagram[i][j].bgr }]"
        >
          {{ diagram[i][j].letter }}
        </td>
      </tr>
    </table>
    <mb-audio
      v-if="startData.audioSrc"
      :item-audio="{ audioSrc: startData.audioSrc, position: 'absolute', audioCss: startData.audioCss }"
    >
    </mb-audio>
  </div>
</template>

<script>
import _ from 'lodash';
import * as utils from '../../Utils/inputUtils';
import MbAudio from '__mainSrcDir/components/MbAudio/MbAudio';
export default {
  name: 'mp-find-words',
  components: { MbAudio },
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      startData: {},
      diagram: [],
      selectLetters: false,
      checkWord: [],
      checking: '',
      solved: [],
      imageData: {},
    };
  },
  beforeMount() {
    this.newGame();
  },
  mounted() {},
  methods: {
    resetCheckStatus() {
      this.$store.dispatch('resetCheckStatus');
      /** @type {Boolean}  return true becouse want to event to propagate  */
      return true;
    },
    newGame() {
      if (this.startGameConfig.mainImage) {
        this.imageData = this.startGameConfig.mainImage;
      } else if (this.startGameConfig.background) {
        this.imageData = Object.assign({}, { imagePath: this.startGameConfig.background });
      }

      this.selectLetters = false;
      this.startData = this.startGameConfig.sample[0];
      this.diagram = [];
      this.checkWord = [];
      this.checking = '';
      this.solved = [];
      for (let i = 0; i < this.startData.diag.length; i++) {
        this.diagram[i] = [];
        for (let j = 0; j < this.startData.diag[i].length; j++) {
          this.diagram[i][j] = this.startData.diag[i][j];
          this.diagram[i][j] = {
            letter: this.startData.diag[i][j],
            bgr: this.startGameConfig.colors.bgr,
          };
        }
      }

      window.addEventListener('mouseup', this.mouseUpEvent, true);
    },
    mouseUpEvent(e) {
      this.checkLetter(e);
    },
    resetGameAction() {
      window.removeEventListener('mouseup', this.mouseUpEvent, true);
      this.newGame();
      for (let i = 0; i < this.startData.diag.length; i++) {
        for (let j = 0; j < this.startData.diag[i].length; j++) {
          let id = i + '-' + j + '-' + this.startData.diag[i][j];
          this.$refs[id][0].style.backgroundColor = this.startGameConfig.colors.bgr;
        }
      }
    },
    checkGameAction() {
      return this.solved.length === this.startData.correct.length;
    },
    selectLetter(a) {
      if (
        this.selectLetters == false ||
        typeof a.target.id !== 'string' ||
        a.target.id.length == 0 ||
        typeof this.$refs[a.target.id] !== 'object' ||
        this.$refs[a.target.id] == null
      ) {
        return false;
      }
      let d = a.target.id.split('-');
      let c = [parseInt(d[0]), parseInt(d[1])];
      var flg = false;
      for (let i = 0; i < this.checkWord.length; i++) {
        if (JSON.stringify(this.checkWord[i]) == JSON.stringify(c)) {
          flg = true;
          break;
        }
      }
      if (!flg) {
        this.$refs[a.target.id][0].style.backgroundColor = this.startGameConfig.colors.sel;
        this.checkWord.push([parseInt(d[0]), parseInt(d[1])]);
      }
    },
    touchLetter(a) {
      a.preventDefault();
      this.resetCheckStatus();
      var td = document.elementFromPoint(a.changedTouches[0].pageX, a.changedTouches[0].pageY);
      if (td.id) {
        if (a.type == 'touchstart') this.selectLetters = true;
        if (this.selectLetters) {
          td = document.elementFromPoint(a.changedTouches[0].pageX, a.changedTouches[0].pageY);
          this.selectLetter({ target: { id: td.id } });
        }
      }
      if (a.type == 'touchend') {
        this.selectLetters = false;
        this.checkWords();
      }
    },
    checkLetter(a) {
      a.preventDefault();
      this.resetCheckStatus();
      if (this.checking == a.type) return;
      this.checking = a.type;
      if (this.selectLetters) {
        this.selectLetters = false;
        this.checkWords();
      } else {
        this.selectLetters = true;
        this.selectLetter(a);
      }
    },
    checkWords() {
      var isCorrect = false;
      for (let i = 0; i < this.startData.correct.length; i++) {
        if (this.solved.indexOf(i) === -1) {
          if (JSON.stringify(this.checkWord) == JSON.stringify(this.startData.correct[i].cord)) {
            this.coloringWord(this.startData.correct[i].color);
            isCorrect = true;
            this.solved.push(i);
            break;
          }
        }
      }
      if (this.solved.length === this.startData.correct.length) {
        this.$store.dispatch('checkGame', this.checkGameAction());
        this.$store.commit('CHECK_GAME', false);
      }
      if (!isCorrect) this.coloringWord(this.startGameConfig.colors.bgr);
      this.checkWord = [];
    },
    coloringWord(color) {
      for (let i = 0; i < this.checkWord.length; i++) {
        let id =
          this.checkWord[i][0] +
          '-' +
          this.checkWord[i][1] +
          '-' +
          this.diagram[this.checkWord[i][0]][this.checkWord[i][1]].letter;
        if (color !== this.startGameConfig.colors.sel && color !== this.startGameConfig.colors.bgr) {
          this.diagram[this.checkWord[i][0]][this.checkWord[i][1]].bgr = color;
        }
        if (
          color == this.startGameConfig.colors.bgr &&
          this.diagram[this.checkWord[i][0]][this.checkWord[i][1]].bgr != this.startGameConfig.colors.sel
        ) {
          this.$refs[id][0].style.backgroundColor = this.diagram[this.checkWord[i][0]][this.checkWord[i][1]].bgr;
        } else {
          this.$refs[id][0].style.backgroundColor = color;
        }
      }
    },
    getStyle(item) {
      return _.merge({}, this.getCustomStyle(item));
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item && item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
    getImageStyle(imageData) {
      if (_.isObject(imageData) && imageData.imagePath) {
        if (!imageData.pos) {
          imageData = Object.assign({}, imageData, {
            pos: {
              x: 0,
              y: 0,
            },
          });
        }
        if (!imageData.height) {
          imageData = Object.assign({}, imageData, {
            height: 358,
          });
        }
        if (!imageData.width) {
          imageData = Object.assign({}, imageData, {
            width: 1850,
          });
        }
      }
      return _.merge({ position: 'absolute' }, this.getCustomStyle(imageData), {
        'background-image': `url(${require(`__staticDir/${this.$store.getters.multibookType}/${imageData.imagePath}`)})`,
        top: utils.elementTopPosition(imageData.pos.y, imageData.offsetVertical),
        left: utils.elementLeftPosition(imageData.pos.x, imageData.offsetHorizontal),
        width: utils.elementWidth(imageData.width),
        height: utils.elementHeight(imageData.height),
      });
    },
    /**
     * test if object objectExist
     * @method objectExist
     * @param  {*}    item testiing element
     * @return {Boolean}         true if is object
     */
    objectExist(item) {
      return _.isObject(item) && !_.isNil(item.imagePath);
    },
  },
  computed: {
    checkGame() {
      return this.$store.getters.checkGame;
    },
    resetGameSwitch() {
      return this.$store.getters.resetGame;
    },
  },
  watch: {
    checkGame: function (newStatus, oldStatus) {
      if (newStatus) {
        this.$store.dispatch('checkGame', this.checkGameAction());
        this.$store.commit('CHECK_GAME', false);
      }
    },
    resetGameSwitch(newStatus, oldStatus) {
      // console.log('newStatus', newStatus);
      if (newStatus) {
        this.resetGameAction();
        this.$store.dispatch('resetGame');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$elementWidth: 1853px;
$elementHeight: 153px;
.game-container {
  display: flex;
  padding-top: 200px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  .main-image-container {
    position: relative;
    display: block;
    width: $elementWidth;
    height: $elementHeight;
    margin-bottom: 10px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    z-index: -333;
  }
}

.game-container table {
  border-collapse: collapse;
  font-weight: bold;
}

.game-container td {
  border: 1px solid black;
  vertical-align: central;
  text-align: center;
  padding: 0.25em 0.5em;
}
</style>
